import { useNavigate } from 'react-router-dom';
import { dashboardCards } from '@/config/menuConfig';
import { usePermissions } from '@/hooks/usePermissions';
import MenuCard from './MenuCard';

const Dashboard = () => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-admin-text mb-2">ダッシュボード</h1>
        <p className="text-admin-textLight">管理機能を選択してください</p>
      </div>

      <div className="grid grid-cols-1 tablet:grid-cols-2 gap-6">
        {dashboardCards.map((card) => {
          const isAllowed = !card.permissionRequired || hasPermission(card.permissionRequired);

          return (
            <MenuCard
              key={card.id}
              title={card.title}
              description={card.description}
              icon={card.icon}
              isAvailable={card.isAvailable && isAllowed}
              onClick={() => handleCardClick(card.path)}
              permissionRequired={card.permissionRequired}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Dashboard;
